import type { TerminalFileView } from "@/lib/terminal/file-view"

// The File's Brief as plain prose, shown whole: its claims, then the scope
// sentence. The prose stays ordinary, selectable text.
export const FileBrief = ({
  brief,
}: {
  brief: NonNullable<TerminalFileView["brief"]>
}) => (
  <section aria-label="Brief" className="flex w-full flex-col gap-4">
    {brief.paragraphs.map((claims, paragraphIndex) => (
      <p
        key={paragraphIndex}
        className="type-brief max-w-(--terminal-file-brief-max-measure)"
      >
        {claims.map(({ text }) => text).join(" ")}
      </p>
    ))}
    {brief.scopeSentence && (
      <p className="type-brief max-w-(--terminal-file-brief-max-measure)">
        {brief.scopeSentence}
      </p>
    )}
  </section>
)
